<template>
  <div class="home-page d-flex min-vh-100">
    <CContainer fluid>
      <CRow>
        <CCol>
          <CHeader fixed with-subheader light class="header-nav">
            <CHeaderBrand class="mx-auto site_logo" to="/">
              <img
                src="@/assets/icons/logoLR_yoko.svg"
                height="48"
                class="img-fluid"
                alt="Liberty"
              />
            </CHeaderBrand>
          </CHeader>
        </CCol>
      </CRow>

      <CRow class="mt-5 pt-5 justify-content-center">
        <CCol sm="11" lg="9">
          <CRow>
            <CCol>
              <CForm class="member-info edit-form">
                <CRow>
                  <CCol class="px-0 pb-3">
                    <h4 class="sub-title">メールアドレス追加</h4>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <!-- <p>{{ itemToEdit }}</p> -->
                    <div class="required-mark form-group form-row">
                      <label class="col-form-label col-sm-3">カードID</label>
                      <div class="col-sm-9">
                        <input
                          type="number"
                          class="form-control"
                          v-model="ConvertId"
                        />
                      </div>
                    </div>
                    <div
                      class="text-danger input-info"
                      v-if="
                        $v.itemToEdit.cardId.$dirty &&
                        !$v.itemToEdit.cardId.required
                      "
                    >
                      カードIDの入力は必須です
                    </div>
                    <div
                      class="text-danger input-info"
                      v-if="
                        $v.itemToEdit.cardId.$dirty &&
                        !$v.itemToEdit.cardId.numeric
                      "
                    >
                      カードIDは数値を入力してください
                    </div>
                    <div
                      class="text-danger input-info"
                      v-if="
                        $v.itemToEdit.cardId.$dirty &&
                        !$v.itemToEdit.cardId.maxLength
                      "
                    >
                      カードIDは{{
                        valid.itemToEdit.cardId.length
                      }}桁の数値を入力してください
                    </div>
                    <div
                      class="text-danger input-info"
                      v-if="
                        $v.itemToEdit.cardId.$dirty &&
                        !$v.itemToEdit.cardId.minLength
                      "
                    >
                      カードIDは{{
                        valid.itemToEdit.cardId.length
                      }}桁の数値を入力してください
                    </div>
                    <!-- <CInput
                    label="カードID"
                    class="required-mark"
                    horizontal
                    v-model="ConvertId"
                  /> -->

                    <!-- <input type="text" v-model="ConvertId" /> -->
                  </CCol>
                </CRow>

                <CRow>
                  <CCol>
                    <CInput
                      label="氏名"
                      class="required-mark"
                      horizontal
                      v-model="itemToEdit.fullName"
                    />
                    <span
                      class="input-info text-danger"
                      v-if="
                        $v.itemToEdit.fullName.$dirty &&
                        !$v.itemToEdit.fullName.required
                      "
                    >
                      氏名の入力は必須です
                    </span>
                    <CInput
                      label="生年月日"
                      horizontal
                      class="required-mark"
                      placeholder="生年月日"
                      v-model="itemToEdit.birth"
                      type="date"
                    >
                    </CInput>
                    <span
                      class="input-info text-danger"
                      v-if="
                        $v.itemToEdit.birth.$dirty &&
                        !$v.itemToEdit.birth.required
                      "
                    >
                      生年月日の入力は必須です
                    </span>

                    <CInput
                      label="メールアドレス"
                      class="required-mark"
                      horizontal
                      v-model="itemToEdit.email"
                    />
                    <span
                      class="input-info text-danger"
                      v-if="
                        $v.itemToEdit.email.$dirty &&
                        !$v.itemToEdit.email.required
                      "
                    >
                      メールアドレスの入力は必須です
                    </span>
                    <span
                      class="input-info text-danger"
                      v-if="
                        $v.itemToEdit.email.$dirty &&
                        !$v.itemToEdit.email.alphaEmailValidator
                      "
                    >
                      メールの形式が正しくありません。
                    </span>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <div class="my-5 pr-10">
                      <CButton
                        @click="
                          $v.itemToEdit.$invalid ? requiredFd() : saveProfile()
                        "
                        color="success"
                        class="ml-0 px-5 mb-5"
                        v-bind:class="
                          $v.itemToEdit.$invalid ? 'inactive' : 'active'
                        "
                      >
                        <i class="icon cil-user-follow"></i> メール登録
                      </CButton>
                      <CButton
                        color="light"
                        class="float-right"
                        @click="goHomePage()"
                        ><i class="icon cil-arrow-left"></i> 戻る</CButton
                      >
                      <CAlert color="info"
                        >この後、登録したメールアドレスに「メールアドレス認証」と「パスワード更新」メールを送信します。
                        メール内容に従ってログイン用のパスワードを設定してから、ログインしてください。</CAlert
                      >
                    </div>
                  </CCol>
                </CRow>
              </CForm>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="footer fixed-bottom">
        <CCol>
          <CRow class="justify-content-center pt-4">
            <CCol class="app_section"> </CCol>
          </CRow>
          <CRow>
            <CCol>
              <TheFooter />
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CContainer>

    <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      <template #header>
        <h4>登録完了</h4>
      </template>
      登録が完了しました。
      <template #footer>
        <CButton @click="goHomePage()" color="success"
          ><i class="icon cil-send"></i> ホームページに戻る</CButton
        >
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import historykana from "historykana";
import * as wanakana from "wanakana";
import TheFooter from "@/containers/TheFooter";
const alphaEmailValidator = helpers.regex(
  "alphaEmail",
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

const CARD_ID = { LENGTH: 16 };

export default {
  components: {
    // FamilyMember
    TheFooter,
  },
  name: "AddMemberId",
  data() {
    return {
      confirmModal: false,
      completedModal: false,
      cardIdEditModal: false,
      history: [],
      admin: false,
      currentItems: {},
      itemToEdit: {
        fullName: "",
        email: "",
        birth: "",
        cardId: "",
      },

      newCardId: "",
      valid: {
        cardId: { length: CARD_ID.LENGTH },
      },
       
    };
  },
  computed: {
    ConvertId: {
      get() {
        return this.itemToEdit.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.itemToEdit.cardId = conv;
      },
    },
  },
  validations() {
    return {
      itemToEdit: {
        fullName: {
          required,
          maxLength: maxLength(100),
        },
        email: { required, alphaEmailValidator },
        birth: { required },
        cardId: {
          required,
          numeric,
          minLength: minLength(CARD_ID.LENGTH),
          maxLength: maxLength(CARD_ID.LENGTH),
        },
      },
    };
  },
  methods: {
    saveProfile: function () {
      var urlRequest;
      urlRequest = "/api/users/" + this.itemToEdit.cardId;

      axios
        .post(urlRequest, this.itemToEdit, {
          headers: { "api-token": "Eg=HyTs(;^5%Bv6y" },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.itemToRead = resp.data;
          this.itemToEdit = {
            fullName: "",
            email: "",
            birth: "",
            cardId: "",
          };
          this.confirmModal = false;
          this.completedModal = true;
        })
        .catch((err) => {
          this.confirmModal = false;
           
          console.log("Updating profile error: " + err);
          this.errorDialog = true;
          if (err.response.status == 400) {
            this.errors = "このユーザーはすでに存在します";
          } else {
            this.errors = err;
          }
        });
    },

    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    requiredFd() {
      this.$v.itemToEdit.$touch();
    },
    goHomePage() {
      this.$router.push({
        name: "Home",
      });
    },
    resetClose() {
      this.completedModal = false;
    },
  },
  beforeMount() {},
};
</script>